<template>
    <a-modal
    centered
    title="商品选择"
    :width="1200"
    :bodyStyle="{padding: '16px'}"
    :visible="visible"
    :maskClosable="false"
    :destroyOnClose="true"
    @ok="confirm"
    @cancel="cancel"
    >
        <div class="font-weight font-big mb16 text-color-85">当前仓库：{{warehouseName}}</div>
        <div class="flex flex-align-start batch-add-goods-modal">
            <div>
                <div class="pl24 pt16 pb16 border-right-e8 font-weight font-big border-bottom-e8 text-color-85">
                    商品分类
                </div>
                <a-menu mode="inline" style="width: 158px; height: 595px;" :selectedKeys="cateSelectedKeys" @select="cateSelect">
                    <template v-for="item in goodsList">
                        <a-menu-item :key="item.id" class="no-margin border-bottom-e8">
                            {{item.categoryName}}
                        </a-menu-item>
                    </template>
                </a-menu>
            </div>
            <div class="pl16 pr16 pb16 pt16 flex-extensible">
                <div class="mb24">
                    <a-form :form="form" layout="inline" >
                        <a-form-item label="商品编号">
                            <a-input placeholder="请输入" v-decorator="['goodsNo']" autocomplete="off"></a-input>
                        </a-form-item>
                        <a-form-item label="商品名称">
                            <a-input placeholder="请输入" v-decorator="['goodsName']" autocomplete="off"></a-input>
                        </a-form-item>
                        <a-form-item label="条形码">
                            <a-input placeholder="请输入" v-decorator="['goodsBarCode']" autocomplete="off"></a-input>
                        </a-form-item>
                        <a-button type="primary" @click="search">筛选</a-button>
                        <a-button @click="handleReset">重置</a-button>
                    </a-form>
                </div>
                <div>
                    <a-table
                    bordered
                    size="middle"
                    :columns="columns"
                    :rowSelection="{type: 'checkbox', onChange: tableSelectChange, selectedRowKeys: tableSelectedRowKeys}"
                    :pagination="pagination"
                    :dataSource="dataSource"
                    :rowKey="item => item.id"
                    @change="changePage"
                    class="wrap-table"
                    >
                        <template slot="empty" slot-scope="key, row, index">
                            {{key || "-"}}
                        </template>
                    </a-table>
                </div>
            </div>
        </div>
    </a-modal>
</template>
<script type="text/javascript">
    import { mapGetters } from "vuex";
    let columns = [
        {
            title: '商品条形码',
            dataIndex: 'goodsBarCode',
            scopedSlots: { customRender: 'empty' },
            width: '16%'
        },
        {
            title: '商品编号',
            dataIndex: 'goodsNo',
            width: '16%'
        },
        {
            title: '商品名称',
            dataIndex: 'goodsName',
            width: '16%'
        },
        {
            title: '商品规格',
            dataIndex: 'goodsSpecification',
            width: '16%'
        },
        {
            title: '库存数量',
            dataIndex: 'currentInventory',
            width: '16%'
        },
        {
            title: '可用数量',
            dataIndex: 'availableInventory'
        }
        ];
    export default {
        name: 'goodsBatchPicker',
        components: {},
        props: {
            goodsList: {
                type: Array,
                default: () => {return []}
            },
            selectedRowKeys: {
                type: Array,
                default: () => {return []}
            },
            warehouseName: {
                type: String,
                default: '主仓库'
            }
        },
        data() {
            return {
                columns,
                dataSource: [],
                flatData: [],
                pagination: {
                    showTotal: total => `共 ${total} 条数据`,
                    total: 0,
                    current: 1,
                    pageSize: 10
                },
                visible: false,
                cateSelectedKeys: [],
                tableSelectedRowKeys: []
            };
        },
        computed: {
            ...mapGetters(["shopId"])
        },
        watch: {
            visible: {
                handler(val) {
                    if (val && this.goodsList.length > 0) {
                        let flatData = [];
                        let goodsList = this.goodsList;
                        goodsList.forEach(item => {
                            flatData = flatData.concat(this.$utils.deepClone(item.vos));
                        });
                        this.flatData = flatData;
                        this.cateSelectedKeys = [this.goodsList[0].id];
                        this.goodsFilter();
                        this.tableSelectedRowKeys = this.$utils.deepClone(this.selectedRowKeys);
                    } else {
                        setTimeout(() => {this.dataSource = [];}, 300);
                    }
                }
            }
        },
        methods: {
            // 重置筛选
            handleReset() {
                this.form.resetFields();
                this.search();
            },
            search() {
                this.pagination.current = 1;
                this.goodsFilter();
            },
            /**
             * @goodsFilter 商品筛选
             */
            goodsFilter() {
                let flatData = this.flatData;
                let menuSelectedKey = this.cateSelectedKeys[0];
                let { goodsNo, goodsName, goodsBarCode } = this.form.getFieldsValue();
                this.dataSource = flatData.filter(item => {
                    let requirementCate = item.categoryId === menuSelectedKey;
                    let requirementGoodsNo = Boolean(goodsNo) ? new RegExp(goodsNo.replace(/([ .,$ ,^ ,{, [, (, | ,) ,*, +, ?, \\ ])/g, '\\$1')).test(String(item.goodsNo)) : true;
                    let requirementGoodsName = Boolean(goodsName) ? new RegExp(goodsName.replace(/([ .,$ ,^ ,{, [, (, | ,) ,*, +, ?, \\ ])/g, '\\$1')).test(String(item.goodsName)) : true;
                    let requirementGoodsBarCode = Boolean(goodsBarCode) ? new RegExp(goodsBarCode.replace(/([ .,$ ,^ ,{, [, (, | ,) ,*, +, ?, \\ ])/g, '\\$1')).test(String(item.goodsBarCode)) : true;
                    if (requirementCate && requirementGoodsNo && requirementGoodsName && requirementGoodsBarCode) {
                        return true;
                    } else {
                        return false;
                    }
                });
                this.pagination.total = this.dataSource.length;
            },
            //分页回调
            changePage(page) {
                this.pagination = page;
            },
            tableSelectChange(selectedRowKeys, selectedRows) {
                //key即是table的rowKey
                this.tableSelectedRowKeys = selectedRowKeys;
            },
            /**
             * @cateSelect 分类选择
             */
            cateSelect({ item, key, selectedKeys }) {
                this.cateSelectedKeys = selectedKeys;
                this.goodsFilter();
            },
            /**
             * @confirm 确认
             */
            confirm() {
                if (this.$listeners.hasOwnProperty('confirm')) {
                    let { tableSelectedRowKeys } = this;
                    let selectedRows = this.flatData.filter(item => tableSelectedRowKeys.find($item => $item === item.id));
                    this.$emit('confirm', {
                        selectedRowKeys: this.$utils.deepClone(tableSelectedRowKeys), 
                        selectedRows: this.$utils.deepClone(selectedRows)
                    });
                }
                this.visible = false;
                setTimeout(() => {this.tableSelectedRowKeys = [];}, 300);
            },
            /**
             * @cancel 取消
             */
            cancel() {
                this.visible = false;
                setTimeout(() => {this.tableSelectedRowKeys = [];}, 300);
            }
        },
        beforeCreate() {
                this.form = this.$form.createForm(this); //筛选表单
        },
        created() {},
        mounted() {
        }
    };
</script>
<style lang="scss">
    .batch-add-goods-modal {
        border: 1px solid #e8e8e8;
        .border-right-e8 {
            border-right: 1px solid #e8e8e8;
        }
        .border-bottom-e8 {
            border-bottom: 1px solid #e8e8e8;
        }
    }
</style>